import axios from 'axios';
import { constructServiceURL } from '../../../../../utils/URLTools';

export const apiFetchIATAList = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getIataCodesDefault',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.get(serviceURL, payload);
};

export const apiFetchFlightList = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getFlightListDefault',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      iataCode: payload.params,
    },
  });
  return payload.params ? axios.get(serviceURL) : [];
};

export const apiDeactivateFlight = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'deactivateFlightDefault',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      flightId: payload.flightId,
    },
  });
  return axios.delete(serviceURL);
};

export const apiFetchManualFlightById = (payload) => {
  const { iataCode, flightId } = payload.params;
  const serviceURL = constructServiceURL({
    endpoint: 'getManualFlightById',
    stub: process.env.useStubbedEndpoints,
    pathParameters: { iataCode, flightId },
  });
  return payload.params ? axios.get(serviceURL) : [];
};
